import "nprogress/nprogress.css";
import { start, done, configure } from "nprogress";

configure({
  trickleSpeed: 20,
});

function delay(time) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, time);
  });
}
function loadComp(comresolve) {
  return async () => {
    start();
    // if (process.env.NODE_ENV === "development") {
    //   await delay(2000);
    // }
    const comp = await comresolve();
    done();
    return comp;
  };
}
export default [
  {
    path: "/",
    redirect: "/resume",
  },
  // {
  //   path: "/home",
  //   name: "Home",
  //   meta: {
  //     title: "主页",
  //   },
  //   component: () => import("@/views/Home"),
  // },
  {
    path: "/resume",
    name: "Resume",
    meta: {
      title: "主页",
    },
    component: loadComp(() =>
      import(/* webpackChunkName: "resume" */ "@/views/Resume")
    ),
  },
  {
    path: "/blog",
    name: "Blog",
    meta: {
      title: "文章",
    },
    component: loadComp(() =>
      import(/* webpackChunkName: "blog" */ "@/views/Blog")
    ),
  },
  {
    path: "/blog/cate/:categoryId",
    name: "BlogCategory",
    meta: {
      title: "文章",
    },
    component: loadComp(() =>
      import(/* webpackChunkName: "blog" */ "@/views/Blog")
    ),
  },
  {
    path: "/blog/detail/:id",
    name: "BlogDetail",
    meta: {
      title: "文章详情",
    },
    component: loadComp(() =>
      import(/* webpackChunkName: "blogdetail" */ "@/views/Blog/Detail.vue")
    ),
  },
  {
    path: "/write",
    name: "Write",
    meta: {
      title: "写作",
    },
    component: loadComp(() =>
      import(/* webpackChunkName: "write" */ "@/views/Write")
    ),
  },
  {
    path: "/write/tag/:tagId",
    name: "WriteTag",
    meta: {
      title: "写作",
    },
    component: loadComp(() =>
      import(/* webpackChunkName: "write" */ "@/views/Write")
    ),
  },
  {
    path: "/write/detail/:id",
    name: "WriteDetail",
    meta: {
      title: "文章详情",
    },
    component: loadComp(() =>
      import(/* webpackChunkName: "writedetail" */ "@/views/Write/Detail.vue")
    ),
  },
  {
    path: "/project",
    name: "Project",
    meta: {
      title: "项目",
    },
    component: loadComp(() =>
      import(/* webpackChunkName: "project" */ "@/views/Project")
    ),
  },
  // {
  //   name: "Message",
  //   path: "/message",
  //   component: loadComp(() =>
  //     import(/* webpackChunkName: "message" */ "@/views/Message")
  //   ),
  //   meta: {
  //     title: "留言板",
  //   },
  // },
  {
    path: "*",
    name: "NotFound",
    meta: {
      title: "404",
    },
    component: loadComp(() =>
      import(/* webpackChunkName: "404" */ "@/views/NotFound")
    ),
  },
];
